import t from"react";import{Cell as e}from"./styles.js";const l=({children:l,width:a,align:s,colSpan:c,className:o})=>t.createElement(e,{colSpan:c,style:{width:a,textAlign:s},className:o},l);export{l as TableCell};
//# sourceMappingURL=TableCell.js.map
